import { render, staticRenderFns } from "./GlobalPreviewMediaDialog.vue?vue&type=template&id=221de42f&"
import script from "./GlobalPreviewMediaDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalPreviewMediaDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPreviewMediaDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports